module.exports = __webpack_public_path__ + "static/media/flushed.7ee9d898.svg";